import React from 'react';
import styled from 'styled-components';
import { blockPadV, blockW } from 'theme/mixins/padding';
import type { AnimatedMap as T } from './types';

import MapSvg from 'components/MapSvg';

const Wrapper = styled.div`
  ${() => blockPadV()};
  background: ${({ theme }) => theme.themeColors.bg};
  max-width: 100vw;
  overflow-x: hidden;
`;

const Container = styled.div`
  ${() => blockW()};
  overflow: hidden;
  & > * {
    position: relative;
    right: 80px;
    min-width: 800px;
    ${({ theme }) => theme.mq.md`
    min-width: auto;
    right: 0px;
  `}
  }
`;

const AnimatedMap: React.FC<T> = ({}) => {
  return (
    <Wrapper>
      <Container>
        <MapSvg />
      </Container>
    </Wrapper>
  );
};

export default AnimatedMap;
